import { render } from "./RegisterOwner.vue?vue&type=template&id=f58264d0"
import script from "./RegisterOwner.vue?vue&type=script&lang=js"
export * from "./RegisterOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__